import { fetchGet, fetchPost } from './fetch';

const API_URL = '';

export const likeDislike = async (req: { id: string }) => {
  const url = `${API_URL}/api/v1/like/like_dislike`;
  return fetchPost<{ id: string }, { data?: {} }>(url, req);
};
